import React from "react";
import Label from "../../../Common/components/Label";
import BuilderDefinition from "./BuilderDefinition";

const BuilderPreviewComponent = ({ component }) => {

  return (
    <React.Fragment>
      <div
        key={component?.component.uid}
        className="builder-border container-fluid mb-4 pb-0 position-relative ps-3 pt-3 rounded"
        style={{
          background: "#f2f2f2",
          boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.04)",
          borderColor: component.component.is_deleted ? "#dc3545" : "#caccd0",
        }}
      >
        <div className="container-fluid ps-0">
          <div className="form-group col-md-3 ">
            <label
              style={{
                fontWeight: "500",
                fontFamily: "Noto Sans",
                fontSize: "1.125rem",
              }}
              className="pb-1"
            >
              {component?.component.display_name}
            </label>
          </div>
          <div className="row mb-3 mt-2">
            <div className="form-group col-md-4">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Unique Name
              </label>
              <br />
              <Label message={component?.component.unique_name} />
            </div>
            <div className="form-group col-md-4 col-sm-6">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Necessary
              </label>
              <br />
              <Label message={component?.nessie} />
            </div>
            <div className="form-group col-md-4 col-sm-6">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Description
              </label>
              <br />
              <Label message={component?.component.description} />
            </div>
          </div>
        </div>
        <svg
          width="1103"
          height="2"
          viewBox="0 0 1103 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.5"
            d="M0.139893 0.507812L1102.14 0.507716"
            stroke="#C9C9CF"
          />
        </svg>

        {/* <div className="container-fluid ps-0">
          <div className="row mb-3 mt-2">
            <div className="form-group col-md-4">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Category
              </label>
              <br />
              <Label message={"Category"} />
            </div>
            <div className="form-group col-md-4 col-sm-6">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Attribute
              </label>
              <br />
              <Label message={"-"} />
            </div>
            <div className="form-group col-md-4 col-sm-6">
              <label
                className="pb-1"
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                Values
              </label>
              <br />
              <Label message={"Attribute"} />
            </div>
          </div>
        </div> */}

        <div
          className="pb-4 ps-5 pt-3"
          style={{
            width: "90%",
          }}
        >
          {component?.component.definition && (
            <div>
              <BuilderDefinition
                componentDefinition={JSON.parse(component?.component.definition)}
                setUpdatedComponent={null}
                toUpdate={false}
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default BuilderPreviewComponent;
